import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function MindmapBioTopics() {
  return (
    <>

      <AllSubjectTopics  subject="biology" type="mindmap" />

    </>
  );
}

export default MindmapBioTopics;